import { X } from '@mui/icons-material';
import { Autocomplete, Box, FormControl, FormHelperText, FormLabel, MenuItem, TextField, createFilterOptions } from '@mui/material';
import * as React from 'react';

const filter = createFilterOptions();

export default function CustomProductAutocomplete({ values, onChange, error, data, title, required, disabled, valueName, labelName, onInputChange }) {
    return (
        <>
            <FormControl variant="outlined" fullWidth>
                <FormLabel style={{ fontFamily: 'Manrope-Bold', fontSize: 14 }}>{title}{required && <span style={{ color: "red" }}>*</span>}</FormLabel>
                <Autocomplete
                    size="small"
                    value={values || ""}
                    required={required}
                    disabled={disabled}
                    freeSolo
                    filterOptions={(options, params) => {
                        const filtered = filter(options, params);

                        if (params.inputValue !== '') {
                            filtered.push({
                                inputValue: params.inputValue,
                                title: `Add "${params.inputValue}"`,
                            });
                        }

                        return filtered;
                    }}
                    getOptionLabel={(option) => {
                        if (typeof option === 'string') {
                            return option;
                        }
                        if (typeof option === 'number') {
                            const optionData = data?.filter((x, idx) => x?.id === option)
                            return optionData?.[0]?.name;
                        }
                        return option?.[labelName];
                    }}
                    onChange={(e, value) => onChange(e, value)}
                    onInputChange={(event, newInputValue, reason) => {
                        if (reason === "input") {
                            const selected = data?.filter((x, idx) => x?.name === newInputValue)
                            onInputChange(event, newInputValue, selected?.[0]?.id)
                        }

                    }}
                    options={data}
                    renderInput={(params) => <TextField {...params} label="" />}
                    style={{ color: values === "" && "#c8c8c8" }}>
                    {
                        data && data.length > 0 && data.map((x, idx) =>
                            <MenuItem key={idx}
                                value={x.value || x.id || x[`${valueName}`]}
                                style={{
                                    backgroundColor: (x.value || x.id) === values ? '#ED1A3D0D' : 'white',
                                    color: (x.value || x.id) === values ? '#ED1A3D' : '#101010'
                                }}
                            >
                                {x.label || x.name || x[`${labelName}`]}
                            </MenuItem>
                        )
                    }
                </Autocomplete>
            </FormControl>
            {error && <FormHelperText sx={{ color: "red" }}>{error || ""}</FormHelperText>}

        </>


    );
}
